export default __webpack_public_path__ + "media/images/temporary/famous-2-617e383f10d07f19accff38fd6692e73.jpg";